import { render, staticRenderFns } from "./PotSizeDetail.vue?vue&type=template&id=5809c0d8&"
import script from "./PotSizeDetail.vue?vue&type=script&lang=js&"
export * from "./PotSizeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports